import { render, staticRenderFns } from "./AddSupplierType.vue?vue&type=template&id=a0bdbbb2"
import script from "./AddSupplierType.vue?vue&type=script&lang=js"
export * from "./AddSupplierType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports